import React from 'react'

const Cart = () => {
  return (
    <div>
      <h1>cart</h1>
    </div>
  )
}

export default Cart
